/* eslint-disable camelcase */
import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import { WarrantExerciseService } from '@wealthlane/api-services/wealthlane-captable-service';

const usePostRejectWarrantExercise = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  setCheckedValues?: (values: any[]) => void,
  closeModal?: () => void
): UseMutationResult<undefined, unknown, { exerciseIds: string[]; rejectionReason: string }, unknown> => {
  const queryClient = useQueryClient();
  return useMutation(
    async (payload: { exerciseIds: string[]; rejectionReason: string }) => {
      return await handleRequest(
        WarrantExerciseService.postApiCapTableApiAppWarrantExerciseRejectExercise(payload)
      );
    },
    {
      onSuccess: async (response: any) => {
        if (response != null) {
          toast.success(
            <ToastComponent label='Success' message='Exercise request(s) rejected.' />
          );
          setCheckedValues?.([]);
          closeModal?.();
          await queryClient.invalidateQueries('getWarrantExerciseList');
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostRejectWarrantExercise;
